<ng-container>
  <bit-form-field>
    <bit-label>{{ "verificationCode" | i18n }}</bit-label>
    <input
      bitInput
      type="text"
      appAutofocus
      appInputVerbatim
      [formControl]="tokenFormControl"
      (keyup)="onTokenChange($event)"
    />
  </bit-form-field>
</ng-container>
